import { render } from "./decive.html?vue&type=template&id=92517c14&scoped=true&ts=true"
import script from "./device.ts?vue&type=script&lang=ts"
export * from "./device.ts?vue&type=script&lang=ts"

import "./device.scss?vue&type=style&index=0&id=92517c14&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92517c14"]])

export default __exports__